import React, {useState} from 'react';
import {FaHome, FaGamepad, FaWallet, FaUser} from 'react-icons/fa';
import './BottomTabs.css';
import {useNavigate} from 'react-router-dom';

const tabs = [
  {id: 'home', label: 'Home', icon: <FaHome />, path: '/home'},
  {id: 'play', label: 'Play Game', icon: <FaGamepad />, path: '/gamelist'},
  {id: 'wallet', label: 'Wallet', icon: <FaWallet />, path: '/walletoption'},
  {id: 'profile', label: 'Profile', icon: <FaUser />, path: '/profile'},
];

const BottomTabs = () => {
  const [activeTab, setActiveTab] = useState('');
  const navigate = useNavigate();

  const handleTabClick = tab => {
    setActiveTab(tab.id);
    navigate(tab.path);
  };

  return (
    <>
      <div className="appContainer">
        <div className="bottomTabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tabButton ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => handleTabClick(tab)}>
              <div className="tabIcon">{tab.icon}</div>
              <div className="tabLabel">{tab.label}</div>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default BottomTabs;
